<template>
  <div class="record-wrap">
    <section class="search-wrap">
      <div class="search">
        <!-- 下拉切换审批、抄送 -->
        <van-dropdown-menu class="drop-down" v-if="!isShowSearchBar">
          <van-dropdown-item
            v-model="dropdownValue"
            :options="dropdownList"
            @change="dropDownChange"
          />
        </van-dropdown-menu>
        <div class="btns">
          <!-- 搜索框 -->
          <form v-if="isShowSearchBar" class="search-bar" action="/">
            <van-search
              v-model="searchText"
              placeholder="输入学生姓名进行查询"
              shape="round"
              show-action
              @cancel="isShowSearchBar = false"
              @search="onSearch"
              @clear="onSearch"
            ></van-search>
          </form>
          <!-- 搜索和筛选按钮 -->
          <div
            class="search-btn flex-center"
            v-if="!isShowSearchBar"
            @click="isShowSearchBar = true"
          >
            <i class="iconfont">&#xe60b;</i>&nbsp;搜索
          </div>
          <div class="select-btn flex-center" @click="showScreen = !showScreen">
            <i class="iconfont" style="font-size: 18px;">&#xe709;</i>&nbsp;筛选
          </div>
        </div>
      </div>

      <!-- 筛选组件 -->
      <screen-items v-show="showScreen" @submitFun="setCondition"></screen-items>
      <div v-show="!showScreen">
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
          <van-list
            class="refreshWrap"
            v-model="isRefresh"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <ul class="leave-list">
              <li
                class="leave-item clearfix"
                v-for="item in recordList"
                :key="item.LeaveApplicationID"
                @click="editApply(item)"
              >
                <!-- <div class="left fl">
                  <span>{{item.ApplicantName ? xy.showName(item.ApplicantName) : ''}}</span>
                </div> -->
                <div class="left fl">
                  <img class="left-img" v-if="item.Icon" :src=" item.Icon" />
                  <span v-else>
                    {{xy.showName(item.ApplicantName)}}
                  </span>
                </div>
                <div class="right">
                  <div class="title">
                    <!-- ApplicationType 2:代请假 1:自己请假 -->
                    <div
                      class="nowrap tit"
                    >{{item.ApplicantName}}提交的{{item.ApplicationType === 2?'代':''}}请假申请</div>
                    <div class="date fr">{{xy.moment(item.CreateByDate).format("YYYY-MM-DD HH:mm")}}</div>
                  </div>
                  <!-- IsCycleLeave true周期性请假 -->
                  <div
                    class="type"
                  >请假类型：{{item.LeaveTypeName}}&nbsp;&nbsp;{{item.IsCycleLeave?'周期性请假':''}}</div>
                  <div class="info">
                    <img :src="cardImgUrl" alt />
                    <div class="right-con">
                      <p>
                        <span class="date">
                          {{ xy.moment(item.StartTime).format("YYYY/MM/DD") }}
                          &nbsp;&nbsp;
                          {{!item.IsCycleLeave? xy.moment(item.StartTime).format("HH:mm"):'' }}
                        </span>
                      </p>
                      <p>
                        <span class="date">
                          {{ xy.moment(item.EndTime).format("YYYY/MM/DD") }}
                          &nbsp;&nbsp;
                          {{!item.IsCycleLeave? xy.moment(item.EndTime).format("HH:mm"):'' }}
                        </span>
                      </p>
                    </div>
                  </div>
                  <!-- 0待审批，1审批中，2已通过，3已拒绝，4已撤销，5已过期 （40已撤回） -->
                  <div
                    class="status"
                    v-if="item.ApplicationState !== -1"
                    :style="{color: (item.ApplicationState === 0 ? '#4196FF' : item.ApplicationState === 1 ? '#E8A022' : item.ApplicationState === 2 ? '#21A83E' : item.ApplicationState === 3 ? '#D83737' : item.ApplicationState === 4 ? '#666666' : item.ApplicationState === 5 ? '#666666' : '')}"
                  >{{item.ApplicationStateName}}</div>
                </div>
              </li>
            </ul>
          </van-list>
        </van-pull-refresh>
      </div>
    </section>
  </div>
</template>
<script>
import ScreenItems from "../../components/ScreenItems";

import xy from "@/common/utils";
import { Notify } from "vant";
const cardImgUrl = require("@/assets/attendance/data_ask.png");
export default {
  name: "StudentLeaveSubApproval",
  components: {
    ScreenItems
  },
  data() {
    return {
      cardImgUrl,
      // imgUrl: this.xyMApi + '/base',
      isRefresh: false,
      finished: false,
      recordList: [],
      searchText: "",
      leaveTypeID: 0,
      timeType: 0,
      applicationState: -1,
      pageIndex: 1,
      pageSize: 15,
      isLoading: false,
      type: "1",

      isShowSearchBar: false, //搜索框展示
      showScreen: false,

      startDate: "", //开始时间
      endDate: "", //结束时间
      //是否为审批：审批or抄送
      isApproval: true,
      //下拉菜单
      dropdownValue: 1,
      dropdownList: [{ text: "审批", value: 1 }, { text: "抄送", value: 2 }],
    };
  },
  created() {
    this.$store.commit("attendance/setFirstLoad", true);
  },
  methods: {
    //切换审批和抄送
    dropDownChange(value) {
      
      // this.$set(this, 'finished', false)
      this.$set(this, 'recordList', [])
      this.$set(this, 'pageIndex', 1)
      if (value === 1) {
        //审批：1
        this.isApproval = true;
      } else if (value === 2) {
        //抄送：2
        this.isApproval = false;
      }
      this.pageIndex = 1;
      this.recordList = [];
      if(this.finished){
        this.finished = false
      }else{
        this.onLoad()
      }
    },
    //重置条件
    resetAndLoad() {
      this.pageIndex = 1;
      this.recordList = [];
      setTimeout(()=>{
        this.onLoad();
      },500)
      
    },
    editApply(val) {
      this.$store.commit("attendance/setVal", val);
      this.$store.commit("attendance/settype", this.type);
      this.$router.push({
        path: "/home/StudentLeave/ApprovalDetails",
        query: {
          isRevoke: this.IsRevoke
        }
      });
    },
    onRefresh() {
      setTimeout(() => {
        this.recordList = [];
        this.pageIndex = 1;
        this.isLoading = false;
        this.onLoad();
      }, 500);
    },
    transferDate: xy.transferDate,
    onSearch() {
      this.resetAndLoad()
    },
    setCondition(leave) {
      console.log(leave);
      this.startDate = leave.startDate;
      this.endDate = leave.endDate;
      this.leaveTypeID = leave.leaveType;
      this.applicationState = leave.approvalStatus;
      this.searchText = "";
      this.showScreen = false;
      this.pageIndex = 1;
      this.recordList = [];
      if(this.finished){
        this.finished = false;
      }else{
        this.onLoad();
      }
    },

    async getList() {
      if(!this.$store.state.attendance.firstLoad && this.recordList.length === 0){
        this.xy.loading()
      }
      var types = 1;
      if (this.isApproval) {
        types = 1;
      } else {
        types = 2;
      }
      var params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        studentName: this.searchText,
        leaveTypeID: this.leaveTypeID,
        startDate: this.startDate, //开始时间
        endDate: this.endDate, //结束时间
        timeType: 0,
        applicationState: this.applicationState,
        pageType: types //1审批 2抄送
      };
      let res = await this.xyapi.get(
        this.xyMApi +
          "/att/api/StudentLeaveMb/SelfApprovalGetPageMobile",
        params
      );
      if (res.success) {
        // 加载状态结束
        this.xy.unloading();
        this.$store.commit("attendance/setFirstLoad", false);
        let _list = res.data.data;
        this.recordList =  [...this.recordList, ..._list];
        this.pageIndex++;
        this.finished = this.recordList.length >= res.data.totalRecords ? true : false;
        this.isRefresh = false
      } else {
        Notify({ type: "danger", message: res.msg });
      }
    },
    onLoad(params = null) {
        params = Object.assign({ pageIndex: this.pageIndex }, params);
        this.getList(params);     
    }
  }
};
</script>
<style lang="less" scoped>
.record-wrap {
  padding-bottom: 80px;

  .search-wrap {
    .search {
      display: flex;
      background: #fff;
      height: 100px;
      padding: 0 15px;
      .drop-down {
        flex: 3;
        background: #f3f3f3;
        margin: 14px 20px 14px 0;
        height: 72px;
        border-radius: 6px;
      }
      .btns {
        flex: 2;
        display: flex;
        color: #505050;
        align-items: center;
        .search-btn {
          flex: 1;
        }
        .search-bar {
          flex: 4;
        }
        .select-btn {
          flex: 1;
        }
      }
    }
  }
  // list
  .refreshWrap {
    .leave-list {
      padding: 15px;
      .leave-item {
        background: #fff;
        border-radius: 14px;
        box-shadow: 0px 2px 21px 0px rgba(197, 197, 197, 0.5);
        margin-bottom: 16px;
        padding: 12px 31px 22px 19px;
        .left {
          width: 64px;
          height: 64px;
          display: flex;
          align-items: center;
          justify-content: center;
          .left-img{
            width:100%;
            height:100%;
            border-radius: 50%;
          }
          span {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 64px;
            height: 64px;
            text-align: left;
            border-radius: 50%;
            background: @blue;
            font-size: 22px;
            color: #fff;
          }
        }
        .right {
          padding-left: 87px;
          .title {
            display: flex;
            justify-content: space-between;
            .tit {
              flex: 1;
              max-width: 60%;
              font-size: 30px;
              line-height: 64px;
              font-weight: bold;
              color: #333;
            }
            .date {
              line-height: 64px;
              color: #b4b4b4;
              font-size: 24px;
            }
          }
          .type {
            font-size: 24px;
            color: #999;
            width: fit-content;
            height: 36px;
            line-height: 36px;
            padding: 0 20px 0 11px;
            background: rgba(249, 249, 249, 1);
            border-radius: 14px 0px 14px 0px;
          }
          //请假周期时间
          .info {
            margin-top: 15px;
            display: flex;
            color: #666;
            img {
              width: 13px;
              height: 73px;
              margin-top: 10px;
              margin-right: 10px;
            }
            .right-con {
              font-size: 26px;
              .date {
                margin-right: 10px;
              }
              p:first-child {
                margin-top: 2px;
              }
              p:last-child {
                margin-top: 31px;
              }
            }
          }
          //状态
          .status {
            font-size: 28px;
            margin: 17px 0 0;
            color: #666;
          }
        }
      }
    }
  }
}
</style>
